import { logUnifiedTelemetry } from "owa-analytics";
import type { RoomComparisonData } from "./scheduling/getRoomComparisonData";
import { type UTCalendarFeatureName, type UTCalendarUIContext, type UTCalendarEventFeatureAction, type IUTECalendarEventUserActionArgs, type UTPlaceResourceType, type UTCalendarOrigin, type IUTSpaceReservationDataArgs } from "@outlook/unified_telemetry";

export default function logSpaceReservation(spaceType: UTPlaceResourceType, entryPoint: {
    context: UTCalendarUIContext;
    origin?: UTCalendarOrigin;
}, 

// Indicates the action taken by the user
featureAction: UTCalendarEventFeatureAction, 

// The UI context in which the action was taken
uiContext: UTCalendarUIContext, origin?: UTCalendarOrigin, 

// Optional datas
calendarEventData?: Pick<IUTECalendarEventUserActionArgs, "IsNew" | "ChangedPropertyNameList">, spaceReservationData?: Omit<IUTSpaceReservationDataArgs, "SpaceType">, 

// If empty, it means the action was successful
failureInfo?: string, roomComparisonData?: RoomComparisonData): void {
    const data: IUTECalendarEventUserActionArgs = {
        FeatureName: "SpaceReservation",
        FeatureAction: featureAction,
        FeatureUIContext: uiContext,
        Origin: origin,
        ActionSuccess: !failureInfo,
        ActionFailureInfo: failureInfo,
        SourceUIContext: entryPoint.context,
        SourceOrigin: entryPoint.origin,
        ...(calendarEventData || {}),
        ...(roomComparisonData
            ? {
                EventLocationMetrics: {
                    LocationRoomsCount: spaceType === "Room" ? 1 : 0,
                    LocationBingCount: 0,
                    LocationExplicitTypedCount: 0,
                    RoomComparisonData: JSON.stringify(roomComparisonData),
                },
            }
            : undefined),
        SpaceReservationData: {
            SpaceType: spaceType,
            ...spaceReservationData,
        },
    };
    logUnifiedTelemetry({
        eventName: "CalendarEventUserAction",
        bypassEventMatchingCheck: true,
        data,
    });
}
